import { z } from 'zod';

import { CaseWikiContextUserInputsBodySchema } from './context-user-inputs.js';
import { CaseWikiLaunchResultSchema } from './wiki-dispatch.js';

/** Strict browser contract for the authenticated Case Wiki launch route. */
export const CaseWikiResumeRequestSchema = CaseWikiContextUserInputsBodySchema.extend({
  // WHY: the backend lands before the frontend during the rolling deployment.
  // A missing field therefore identifies the legacy UI, whose button promised
  // an immediate launch. The new UI always sends `policy` explicitly.
  dispatch_mode: z.enum(['policy', 'immediate']).default('immediate'),
}).strict();
export type CaseWikiResumeRequest = z.infer<typeof CaseWikiResumeRequestSchema>;

/**
 * Réponse de POST /api/cases/:caseId/wiki/resume.
 *
 * The same launch boundary may start immediately, reuse an active pipeline,
 * or persist a nightly dispatch request.
 */
export const CaseWikiResumeResponseSchema = CaseWikiLaunchResultSchema;

export type CaseWikiResumeResponse = z.infer<typeof CaseWikiResumeResponseSchema>;
